module.exports = __webpack_public_path__ + "static/intro-1282671473.f87ff4b6.jpg";